export function uploadWithProgress(url: string, file: File, onProgress: (percent: number) => void) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.open('PUT', url);

        xhr.setRequestHeader('Content-Type', file.type);

        xhr.upload.onprogress = function (event) {
            const percentComplete = (event.loaded / event.total) * 100;
            if (Number.isNaN(percentComplete)) {
                onProgress(0);
            } else {
                onProgress(percentComplete);
            }

        };

        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.response);
            } else {
                reject(new Error('Failed to upload video'));
            }
        };

        xhr.onerror = function () {
            reject(new Error('Network error during upload'));
        };

        xhr.send(file);
    });
}
